import Vue from 'vue'

import Template from './kontakt.vue'

import { FormValidation, chain, required, valid_email } from '../form/form'

new Vue ({
    name: 'KontaktForm',
    el: '#app',
    extends: FormValidation(Template, {
        vorname     : chain('vorname',     required),
        name        : chain('name',        required),
        email       : chain('email',       required, valid_email),
        tel         : chain('tel',         required),
        nachricht   : chain('nachricht',   required),
        datenschutz : chain('datenschutz', required),
    }),
})
